import { View } from '../../types';

export const RODDO_GUIDED_TOUR_VERSION = 2;

export type RoddoTourStep = {
  id: string;
  view: View;
  target?: string;
  eyebrow?: string;
  title: string;
  body: string;
  note?: string;
  nextLabel?: string;
  pulse?: 'target';
  revealTarget?: string;
  cardPlacement?: 'center' | 'upper' | 'lower';
};

export const RODDO_GUIDED_TOUR_STEPS: RoddoTourStep[] = [
  {
    id: 'nav-hold',
    view: View.BigBlueGlobe,
    target: 'nav-tacklebox',
    eyebrow: 'Your main dock',
    title: 'The Hold',
    body: 'Your gear, loadouts, licenses, stats, and angler setup live here.',
    nextLabel: 'Open Hold',
    pulse: 'target',
  },
  {
    id: 'hold-demo',
    view: View.TackleBox,
    target: 'hold-page',
    eyebrow: 'The Hold',
    title: 'Keep your fishing setup together',
    body: 'Manage rods, reels, lures, licenses, equipped gear, stats, and your angler loadout here.',
  },
  {
    id: 'nav-log',
    view: View.TackleBox,
    target: 'nav-log',
    eyebrow: 'Your main dock',
    title: "Capt’n’s Log",
    body: 'This is where every real fishing trip starts becoming useful history.',
    nextLabel: 'Open Log',
    pulse: 'target',
  },
  {
    id: 'log-demo',
    view: View.LogCatch,
    target: 'log-catch-page',
    eyebrow: "Capt’n’s Log",
    title: 'Log what really happened',
    body: 'Save catches, photos, conditions, gear, locations, and notes from every trip.',
  },
  {
    id: 'nav-big-blue',
    view: View.LogCatch,
    target: 'nav-map',
    eyebrow: 'Your main dock',
    title: 'Big Blue',
    body: 'Big Blue is Roddo’s home base for exploring water and fishing context.',
    nextLabel: 'Open Big Blue',
    pulse: 'target',
  },
  {
    id: 'big-blue-globe',
    view: View.BigBlueGlobe,
    target: 'big-blue-globe',
    eyebrow: 'Big Blue',
    title: 'Explore the world',
    body: 'Start wide on the globe, then dive into the fishing map around the water you care about.',
  },
  {
    id: 'nav-dock',
    view: View.BigBlueGlobe,
    target: 'nav-community',
    eyebrow: 'Your main dock',
    title: 'Dock',
    body: 'Baleen Bay and your fishing community are reached from here.',
    nextLabel: 'Open Dock',
    pulse: 'target',
  },
  {
    id: 'dock-demo',
    view: View.Community,
    target: 'community-page',
    eyebrow: 'Baleen Bay',
    title: 'Fish with the wider community',
    body: 'Share catches, water reports, questions, setups, and fishing conversation with other anglers.',
  },
  {
    id: 'nav-bazaar',
    view: View.Community,
    target: 'nav-bazaar',
    eyebrow: 'Your main dock',
    title: 'Bazaar',
    body: 'Roddo’s gear marketplace is one tap away from the main dock.',
    nextLabel: 'Open Bazaar',
    pulse: 'target',
  },
  {
    id: 'bazaar-demo',
    view: View.Bazaar,
    target: 'bazaar-page',
    eyebrow: 'Baleen Bay Bazaar',
    title: 'Browse the fishing marketplace',
    body: 'Find gear listings, trade with other anglers, and manage your own listings here.',
    nextLabel: 'Back to Big Blue',
    cardPlacement: 'lower',
  },
  {
    id: 'big-blue-map',
    view: View.Map,
    target: 'big-blue-map',
    eyebrow: 'Your fishing map',
    title: 'Explore your water',
    body: 'Weather, saved spots, nearby fishing context, crews, water reads, and events all come together here.',
  },
  {
    id: 'fishiq-launch',
    view: View.Map,
    target: 'map-fishiq',
    eyebrow: 'Read the water',
    title: 'Water Read',
    body: 'This Big Blue control opens Roddo’s water read for the area you are exploring.',
    note: 'Fishing context, not a guarantee.',
    nextLabel: 'Show me',
    pulse: 'target',
  },
  {
    id: 'fishiq-demo',
    view: View.FishIQ,
    target: 'fishiq-page',
    revealTarget: 'fishiq-species-list',
    cardPlacement: 'lower',
    eyebrow: 'Roddo intelligence',
    title: 'Read the water',
    body: 'See the fish list first, then use species, water, timing, weather, and fishing signals to build better context.',
    note: 'Your own logged trips make Roddo more useful over time.',
    nextLabel: 'Back to Big Blue',
  },
  {
    id: 'crew-launch',
    view: View.Map,
    target: 'map-crew',
    eyebrow: 'Fish with people you trust',
    title: 'Crew Dock',
    body: 'This Big Blue control takes you into your private fishing crews.',
    nextLabel: 'Show me',
    pulse: 'target',
  },
  {
    id: 'crew-demo',
    view: View.Crew,
    target: 'crew-page',
    eyebrow: 'Crew Dock',
    title: 'Your trusted anglers',
    body: 'Create private crews for trip planning, bite notes, presence, and conversations with anglers you trust.',
    nextLabel: 'Back to Big Blue',
    cardPlacement: 'lower',
  },
  {
    id: 'tournaments-launch',
    view: View.Map,
    target: 'map-tournaments',
    eyebrow: 'Compete when you want',
    title: 'Tournaments',
    body: 'Big Blue can surface nearby events and take you into the Tournament Dock.',
    nextLabel: 'Show me',
    pulse: 'target',
  },
  {
    id: 'tournaments-demo',
    view: View.Events,
    target: 'tournaments-page',
    eyebrow: 'Tournament Dock',
    title: 'Fish the event',
    body: 'Find events, register, compete solo or with a partner, and submit verified catches through Roddo.',
    nextLabel: 'Back to Big Blue',
  },
  {
    id: 'ready',
    view: View.Map,
    target: 'big-blue-map',
    eyebrow: 'You’re ready',
    title: 'Start fishing',
    body: 'Explore the water. Log what you learn. Build your fishing story from there.',
    nextLabel: 'Start Fishing',
  },
];
